<template>
  <div class="quotations flex-main">
    <div
      class="quotations-item"
      v-for="(item, index) in formatedDatas"
      :key="index"
      :class="fixUpDownColor(item.roseCls)"
    >
      <div @click="bandLink(item)">
        <div class="flex-box">
          <p class="quotations-item-title mb-12">
            <span class="recommendType">
              {{ item.symbol }}
            </span>
          </p>
          <p class="quotations-item-range mb-12">
            <span
              class="percentage"
              :class="fixUpDownColor(item.roseCls)"
            >
              {{ item.roseVal }}
            </span>
          </p>
        </div>
        <div class="flex-box">
          <div class="quotations-item-data">
            <p class="quotations-item-price mb-12">
              <span>
                {{ item.price }}
              </span>
            </p>
            <p class="quotations-item-volume">
              <span v-if="item.contractType === 'E'">
                <span>24H Vol {{ formatNumber(item.volume * item.multiple) }}</span>
                <span v-if="item.volume !== '--'">
                  <span> {{ item.symbol.match(/(\S*)USDT/)[1] }}</span>
                </span>
              </span>
              <span v-else>
                <span>24H Vol {{ formatNumber(item.volume) }}</span>
                <span v-if="item.volume !== '--'">
                  <span> {{ item.symbolName }}</span>
                </span>
              </span>
            </p>
          </div>
          <div :data-name="item.symbol" class="charts-box">
            <charts
              width="110px"
              v-if="klineDataList[item.symbol]"
              :dataList="klineDataList[item.symbol]"
              :colorCls="fixUpDownColor(item.klineColor)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { myStorage } from '@/utilsui';
import { fixUpDownColor } from '@/utils/storage';
import Charts from '../charts/miniChart.vue';

export default {
  name: 'MarketRecommand',
  components: { Charts },
  data() {
    return {
      process: 0,
      dataList: {},
      klineDataList: {},
    };
  },
  computed: {
    recommendData() {
      return this.headerSymbol;
    },
    symbolAll() {
      return this.$store.state.baseData.symbolAll;
    },
    // 合约列表
    contractList() {
      return this.$store.state.future.contractList;
    },
    headerSymbol() {
      if (this.$store.state.baseData.market) {
        return this.$store.state.baseData.market.headerSymbol;
      }
      return [];
    },
    formatedDatas() {
      const arr = [];
      if (this.headerSymbol.length) {
        this.headerSymbol.forEach((symbol) => {
          // 是否为合约数据
          const isFutureData = this.checkFutureData(symbol);
          const obj = {
            symbol: symbol, // 币对
            unit: '', // 币对
            symbolName: '', // 币对
            price: '--', // 价格
            volume: '--', // 24H vol
            roseVal: '--', // 涨跌幅
            roseCls: '', // 涨跌幅颜色
            klineColor: '', // K线颜色
            multiple: '',
          };
          if (this.dataList[symbol]) {
            const data = this.dataList[symbol];
            const roseCls = isFutureData ? this.getFutureRoseClass(data.rose) : this.itemRoseClass(data.rose);
            let roseVal = '--';
            let price = '--';
            if (isFutureData) {
              roseVal = `${(data.rose * 100).toFixed(2)}%`;
              price = data.close || '--';
              obj.contractName = data.contractName;
            } else {
              roseVal = data.rose ? data.rose.data : '--';
              price = data.close ? data.close.data : '--';
            }
            obj.price = price;
            obj.volume = data.vol || '--';
            obj.roseVal = roseVal;
            obj.roseCls = roseCls;
            obj.klineColor = roseCls;
            if (data.contractType === 'E') {
              obj.contractType = data.contractType;
              const contractInfo = this.contractList.filter(item => item.wsDatakey === data.wsDatakey);
              if (contractInfo && contractInfo.length) {
                obj.multiple = contractInfo[0].multiplier;
              }
            } else {
              obj.symbolName = data.symbol.symbol;
            }
          }
          arr.push(obj);
        });
      }
      return arr;
    },
  },
  created() {
    this.init();
  },
  destroyed() {
    this.$bus.$off('RECOMMEEND_DATA');
    this.$bus.$off('EXCHANGE_MARKET_KLINE_DATA');
    this.$bus.$off('FUTURE_MARKET_KLINE_DATA');
  },
  methods: {
    getFutureRoseClass(rose) {
      return rose > 0 ? 'u-1-cl' : 'u-4-cl';
    },

    // 24小时行情 涨跌幅 的背景、样色的class
    itemRoseClass(rose) {
      return rose.class;
    },
    fixUpDownColor,
    /**
     * 带斜杠的认为是现货
     */
    checkFutureData(symbol) {
      return symbol.indexOf('/') === -1;
    },

    formatNumber(num) {
      // 只保留两位小数
      if (isNaN(num)) return num;
      num = parseFloat(num).toFixed(2);

      // 如果小数点后是两个0，就去掉
      if (num.slice(-1) === '0' && num.slice(-2, -1) === '0') {
        num = num.slice(0, -3);
      }

      // 如果整数位超过9位，就用B表示
      if (num > 100000000) {
        num = (num / 100000000).toFixed(2) + 'B';
      }

      // 如果整数位超过7位，就用M表示
      if (num > 1000000) {
        num = (num / 1000000).toFixed(2) + 'M';
      }

      return num;
    },
    init() {
      // 监听 数据
      this.$bus.$on('RECOMMEEND_DATA', (data) => {
        const keys = Object.keys(data);
        keys.forEach((item) => {
          this.$set(this.dataList, item, { ...data[item] });
        });
      });
      this.$bus.$on('EXCHANGE_MARKET_KLINE_DATA', (data) => {
        const keys = Object.keys(data);
        keys.forEach((item) => {
          this.$set(this.klineDataList, item, data[item]);
        });
      });
      this.$bus.$on('FUTURE_MARKET_KLINE_DATA', (data) => {
        const keys = Object.keys(data);
        keys.forEach((item) => {
          this.$set(this.klineDataList, item, data[item]);
        });
      });
    },
    bandLink(data) {
      const symbol = data && data.symbol;
      if (!symbol) {
        return;
      }
      const isFutureData = this.checkFutureData(symbol);
      if (isFutureData) {
        this.$router.push(`/futures/${data.contractName}`);
      } else if (data) {
        myStorage.set('sSymbolName', symbol);
        myStorage.set('markTitle', symbol.split('/')[1]);
        this.$router.push(`/trade/${symbol.replace('/', '_')}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";
.quotations {
  padding: 25px 0;
  .charts-box {
    flex: 1;
  }
  &-item-data {
    width: 132px;
    flex-shrink: 0;
  }
  &-item {
    width: 288px;
    height: 114px;
    padding: 20px;
    box-sizing: border-box;
    border: 1px solid $gray-10;
    border-radius: 8px;
    margin-right: 16px;
    &-title,
    &-range {
      font-size: 18px;
      line-height: 18px;
      font-weight: 500;
      font-family: "Medium";
    }
    &-price {
      font-size: 20px;
      line-height: 20px;
      font-weight: 500;
      font-family: "Medium";
    }
    &-volume {
      font-size: 12px;
      line-height: 12px;
      font-weight: 400;
      color: $gray;
    }
    &-text {
      font-size: 14px;
      line-height: 14px;
      color: $gray;
    }
  }
  .f-flat {
    // 平
    color: $gray;
  }
  .mb-12 {
    margin-bottom: 12px;
  }
}
.flex-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.light {
  .quotations-item {
    border-color: $gray-10;
    background-color: $white;
    &-title {
      color: $light-ft;
    }
  }
}
.dark {
  .quotations-item {
    border-color: $dark-bg-second;
    background-color: $dark-bg-second;
    &-title {
      color: $white;
    }
  }
}

.quotations-item {
  cursor: pointer;
}

.flex-main {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>
